import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "How is LÜVYN different from Hinge, Tinder, or Bumble?",
        a: "We don't show you an infinite scroll of strangers. You'll receive exactly five carefully-matched profiles per week — each chosen by our compatibility engine across 12 dimensions of who you actually are. Quality over quantity, every time.",
    },
    {
        q: "What is the anti-ghosting system?",
        a: "When a conversation goes quiet, we send gentle nudges to both sides. People who consistently engage earn karma, get more visibility, and unlock perks. Ghosting still happens, but we make it less attractive than showing up.",
    },
    {
        q: "How do conversations start?",
        a: "Every weekly match includes a few context-aware prompts based on shared values, interests, and intent. The goal is to make the first message feel specific instead of performative.",
    },
    {
        q: "Is my data really safe?",
        a: "Yes. We are GDPR-compliant by default, we never sell your data, your name is hidden until your first in-person date, and every profile is photo-verified. You can export or delete everything in one tap.",
    },
    {
        q: "When does Alpha launch?",
        a: "We're opening Alpha Wave 01 in early 2026, region by region. Join the waitlist below and we'll send your invite the moment we open your city.",
    },
    {
        q: "Is LÜVYN free?",
        a: "Alpha is free for everyone on the waitlist. After launch, the core 5-matches-per-week experience stays free. Optional premium features, such as advanced filters or extra date planning tools, may be available.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            className="relative py-28 lg:py-36 bg-[var(--paper)]"
            data-testid="faq-section"
        >
            <div className="max-w-5xl mx-auto px-6 lg:px-10">
                <div className="reveal mb-14">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] mb-4">
                        Sect. G — Letters to the editor
                    </div>
                    <h2 className="font-display text-6xl lg:text-9xl leading-[0.85] tracking-tighter">
                        Questions?
                        <br />
                        <span className="font-italic-serif text-[var(--hot)]">
                            Asked & answered.
                        </span>
                    </h2>
                </div>

                <Accordion
                    type="single"
                    collapsible
                    className="reveal w-full border-t-2 border-[var(--ink)]"
                    data-testid="faq-accordion"
                >
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b-2 border-[var(--ink)]"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="text-left font-display text-3xl lg:text-4xl py-7 tracking-tight hover:text-[var(--hot)] hover:no-underline leading-tight">
                                <span className="flex items-baseline gap-5">
                                    <span className="font-mono text-sm text-[var(--hot)] flex-shrink-0">
                                        {`Q.${(i + 1).toString().padStart(2, "0")}`}
                                    </span>
                                    {f.q}
                                </span>
                            </AccordionTrigger>
                            <AccordionContent className="text-[var(--ink-soft)] leading-relaxed text-lg pb-7 pl-[5.5rem] max-w-3xl">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
